(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-ui-clearance"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  const formObservers = new WeakMap();
  const sizeObserver = new ResizeObserver(() => schedule());
  const observedControls = new WeakSet();
  let pending = false;
  let previousClearance = -1;
  let retries = 0;
  let retryTimer = null;

  function bindForms() {
    let waiting = false;
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      const formRoot = host.shadowRoot?.querySelector('[data-form-root]');
      if (!formRoot) {
        waiting = true;
        return;
      }
      if (!formObservers.has(formRoot)) {
        const observer = new MutationObserver(schedule);
        observer.observe(formRoot, {
          attributes: true,
          attributeFilter: ['data-current-step']
        });
        formObservers.set(formRoot, observer);
      }
      const isTeaser = formRoot.getAttribute('data-current-step') === 'tease';
      const value = isTeaser ? 'true' : 'false';
      if (host.getAttribute('data-lp-ui-teaser') !== value) {
        host.setAttribute('data-lp-ui-teaser', value);
      }
    });
    if (waiting && retries < 10 && retryTimer === null) {
      retryTimer = window.setTimeout(() => {
        retryTimer = null;
        retries += 1;
        schedule();
      }, 500);
    }
  }

  function update() {
    pending = false;
    let clearance = 0;
    document.querySelectorAll('.hdt-toolbar, hdt-sticky-btn-atc').forEach((control) => {
      if (!observedControls.has(control)) {
        sizeObserver.observe(control);
        observedControls.add(control);
      }
      const rect = control.getBoundingClientRect();
      const style = getComputedStyle(control);
      if (rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight &&
          rect.bottom > 0 && style.display !== 'none' &&
          style.visibility !== 'hidden' && Number(style.opacity) !== 0) {
        clearance = Math.max(clearance, window.innerHeight - rect.top);
      }
    });
    clearance = Math.max(0, Math.ceil(clearance));
    if (clearance !== previousClearance) {
      root.style.setProperty('--lp-ui-bottom-clearance', clearance + 'px');
      previousClearance = clearance;
    }
    bindForms();
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'opened', 'open-dialog']
  });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('transitionend', schedule);
  document.addEventListener('shopify:section:load', schedule);
  customElements.whenDefined('shopify-forms-embed').then(schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
